import React from 'react';
import styled, { StyledComponentClass } from 'styled-components';
import colors from '../../styles/colors';
import { Icon, IconName } from '../icons';

export interface DataProp {
  value: any;
  label: string;
  color?: string;
}

export interface Props {
  className?: string;
  data: DataProp[];
  icon?: IconName;
  iconColor?: any;
  width?: any;
}

class OverviewWidget extends React.Component<Props, any> {
  public render() {
    const { className, data, icon, iconColor } = this.props;
    return (
      <div className={className}>
        <div className="overview-widget">
          <div className="header">
            <div className="icon-container">
              <div className="icon-outer">
                <Icon
                  icon={icon || 'logo'}
                  baseColor={iconColor || colors.green500}
                />
              </div>
            </div>
          </div>
          <div className="items-container">
            {data.map((item, i) => {
              return (
                <div key={i} className={`item col-${data.length}`}>
                  <div
                    className="item-value"
                    style={item.color ? { color: item.color } : {}}
                  >
                    <div>{item.value}</div>
                  </div>
                  <div className="item-label">
                    <div>{item.label}</div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  }
}

export default styled(OverviewWidget)`
  .overview-widget {
    border: 4px solid ${colors.grey600};
    border-radius: 10px;
    width: ${props => {
      return props.width ? props.width : '225px';
    }};
    height: ${props => {
      return props.width
        ? (props.width.replace('px', '') * 0.8888).toFixed(3) + 'px'
        : '200px';
    }};
  }
  position: relative;
  .header {
    background-color: ${colors.grey600};
    height: 35%;
    .icon-container {
      position: absolute;
      background-color: white;
      border-radius: 50%;
      top: 12%;
      left: 33.33%;
      right: 33.33%;
      bottom: 50%;
      border: 4px solid ${colors.grey600};
      .icon-outer {
        position: absolute;
        width: 50%;
        height: 50%;
        top: 25%;
        left: 25%;
        left: 25%;
        right: 25%;
        > svg {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
  .items-container {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 45%;
    text-align: center;
    .col-1 {
      width: 100%;
    }
    .col-2 {
      width: 50%;
    }
    .item {
      display: inline-block;
      .item-value {
        font-size: ${props =>
          props.width
            ? props.width.replace('px', '') / 100 + 'rem'
            : '2.25rem'};
      }
      .item-label {
        font-size: ${props =>
          props.width
            ? props.width.replace('px', '') / 200 + 'rem'
            : '1.125rem'};
        color: ${colors.grey900};
        text-transform: capitalize;
      }
    }
  }
`;
